import { IState } from "./types";

const initialState: IState = {
  submittingChanges: false,
  loadingTemplates: false,
  loadingSubjects: false,
  loadingAlignmentResults: false,
  templates: [],
  subjects: [],
  alignmentResults: {} as any,
  authenticatingUser: false,
  user: null,
  snackBarState: null,
  updateIds: [],
  config: {} as any,
  loadingConfig: false,
};

export default initialState;
